import script from "./OkrFormFieldSelectTriggerNext.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrFormFieldSelectTriggerNext.vue?vue&type=script&setup=true&lang=js"

import "./OkrFormFieldSelectTriggerNext.vue?vue&type=style&index=0&id=1b5d9b7a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b5d9b7a"]])

export default __exports__